import { cinzaKuppi5, cinzaKuppi6, verdeKuppi2, vermelhoKuppi7 } from "../../../styles/colors";

export const statusConfig = {
  APPROVING: { text: 'Em Análise', color: cinzaKuppi6 },
  APPROVED: { text: 'Ativo', color: verdeKuppi2 },
  REPROVED: { text: 'Rejeitado', color: vermelhoKuppi7 },
  CANCELED: { text: 'Cancelado', color: vermelhoKuppi7 },
  FINISHED: { text: 'Concluído', color: cinzaKuppi5 },
};
